import {
  assignLocalUserToBreakoutRoomRequested,
  leaveBreakoutRoomRequested,
} from 'features/breakout-rooms/actions';
import {
  selectBreakoutRoomBackToMainRoom,
  selectBreakoutRoomsStatus,
  selectIsBreakoutRoom,
  selectLastBreakoutRoom,
} from 'features/breakout-rooms/breakoutRoomsSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import { useTranslation } from 'react-i18next';

export const useLeaveBreakoutControl = () => {
  const { t } = useTranslation('room');
  const dispatch = useAppDispatch();

  const { hasPermissions } = usePermissions();

  const canManageBreakout = hasPermissions(PermissionTypes.manageBreakout);
  const inBreakout = useAppSelector(selectIsBreakoutRoom);
  const backToMainRoom = useAppSelector(selectBreakoutRoomBackToMainRoom);
  const lastBreakoutRoom = useAppSelector(selectLastBreakoutRoom);
  const breakoutsStatus = useAppSelector(selectBreakoutRoomsStatus);

  const canAttendeeLeave = backToMainRoom;
  const leaveBreakoutAvailable = (canManageBreakout || canAttendeeLeave) && inBreakout;

  const returnToBreakoutAvailable =
    !inBreakout && !!lastBreakoutRoom && breakoutsStatus === 'started';

  const available = leaveBreakoutAvailable || returnToBreakoutAvailable;

  const handleAction = () => {
    if (returnToBreakoutAvailable && lastBreakoutRoom) {
      dispatch(assignLocalUserToBreakoutRoomRequested(lastBreakoutRoom.id));
    } else {
      dispatch(leaveBreakoutRoomRequested());
    }
  };

  const label = returnToBreakoutAvailable
    ? t('toolbar.end_session_options.return_to_breakout')
    : t('toolbar.end_session_options.leave_breakout');

  const icon = returnToBreakoutAvailable ? 'person-arrow-back-breakout' : 'end-call';

  return {
    handleAction,
    label,
    icon,
    available,
  };
};
